import { render } from "./CompanyLabView.vue?vue&type=template&id=171b99c4&scoped=true"
import script from "./CompanyLabView.vue?vue&type=script&lang=js"
export * from "./CompanyLabView.vue?vue&type=script&lang=js"

import "./CompanyLabView.vue?vue&type=style&index=0&id=171b99c4&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b99c4"]])

export default __exports__